import React, { useState, useMemo, useEffect } from "react";
import { ZustandStore } from "../../../store/zustand-store";
import { GET_USER_HISTORY } from "../../../services/constants";
import axios from "axios";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { Chip } from "@mui/material";

const LastCheck = ({ type }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const fetchData = async () => {
    const admin_mail = localStorage.getItem("admin_mail");
    if (!admin_mail) return;

    try {
      const response = await axios.get(GET_USER_HISTORY(admin_mail));
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching user history:", error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // No dependencies needed

  const lastSearchData = useMemo(() => {
    if (!data.length) return [];

    const filteredData = data.filter((item) => item.type === type);
    const uniqueArray = filteredData.reduce((acc, item) => {
      if (!acc.some((t) => t.data === item.data)) {
        acc.push(item);
      }
      return acc;
    }, []);
    return uniqueArray.slice(0, 3);
  }, [data, type]);

  const handleHistoryRedirect = (type, item) => {
    switch (type) {
      case "backlinks":
      case "gap":
        ZustandStore.setState({
          get_domain_authority: [],
          backlink_analysis: { data: [], type: "" },
        });
        dispatch({ type: "BACKLINKDOMAIN", payload: item?.data });
        break;
      case "keyword":
        ZustandStore.setState({
          keyword_research_data: {
            data: [],
            loading: false,
            search: false,
            error: false,
          },
          keyword_ques_based_data: {
            data: [],
            loading: false,
            search: false,
          },
          keyword_research_ideas_data: {
            data: [],
            loading: false,
            search: false,
          },
        });
        sessionStorage.setItem("KEYWORD_DOMAIN_NAME", item.data);
        sessionStorage.setItem(
          "KEYWORD_DOMAIN_COUNTRY",
          JSON.stringify(item.location)
        );
        break;
      default:
        ZustandStore.setState({
          worldwide_domain: null,
          site_overview_worldwide: {
            domain: "",
            data: [],
          },
          site_overview_backlink_data: [],
          site_overview_page_data: [],
        });
        const domainLocation = {
          location_name: item?.location.location_name,
          location_code: item?.location.location_code,
          location_flag: item?.location.location_flag,
          language_code: item?.location.language_code,
          language_name: item?.location?.language_name,
          show: item.data === "Worldwide" ? "worldwide" : "",
        };
        sessionStorage.setItem("lastdomainname", item.data);
        sessionStorage.setItem("domainCountry", JSON.stringify(domainLocation));
        sessionStorage.setItem("ISSEARCHTRUE", true);
    }
  };

  const getDomainName = (url) => {
    try {
      return new URL(url).hostname.replace(/^www\./, "");
    } catch {
      return url;
    }
  };

  if (!lastSearchData.length) return null;
  return (
    <div className="heading-small">
      <b>Last Search:</b>{" "}
      {lastSearchData?.map((item) => {
        return (
          <Tooltip title={item.data} arrow disableInteractive key={item.data}>
            <Button
              disableFocusRipple
              sx={{
                padding: "0px 4px",
                "&:hover": {
                  backgroundColor: "transparent", // Adjust hover color
                },
              }}
              onClick={() => handleHistoryRedirect(item.type, item)}
            >
              <Chip
                label={getDomainName(item.data)}
                size="small"
                className="heading-xs"
                sx={{
                  height: "18px",
                  textTransform: "none",
                  "& .MuiChip-label": {
                    lineHeight: "1",
                    fontWeight: "500",
                    fontFamily: "Work Sans",
                    color: "#365486",
                  },
                }}
              />
            </Button>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default React.memo(LastCheck);
